export const getEmptyFormData = (schema = {}) => {
  const keys = Object.keys(schema.properties || {});
  const emptyFormData = {};

  for (const key of keys) {
    emptyFormData[key] = null;
  }

  return emptyFormData;
};
